import React from 'react';
import { Controller } from 'react-hook-form';
import { FormControlLabel, Checkbox, FormControl, FormHelperText } from '@mui/material';

const RHFCheckbox = ({
                         control,
                         name,
                         label,
                         labelPlacement = 'top',
                         color = 'primary',
                         className,
                         disabled,
                         onAfterChange,
                         rules,
                     }) => (
    <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState: { error } }) => (
            <FormControl error={Boolean(error)} component="fieldset" className={className}>
                <FormControlLabel
                    labelPlacement={labelPlacement}
                    control={
                        <Checkbox
                            color={color}
                            disabled={disabled}
                            checked={!!field.value}
                            onChange={(e) => {
                                field.onChange(e.target.checked);
                                if (onAfterChange) onAfterChange(e.target.checked);
                            }}
                            onBlur={field.onBlur}
                        />
                    }
                    label={label}
                />
                {error?.message && <FormHelperText>{error.message}</FormHelperText>}
            </FormControl>
        )}
    />
);

export default RHFCheckbox;